import { Api } from '~/core/trpc'
import { AppSessionType } from '~/features/appSession/common'
import { ToolboxClient } from '~/plugins/toolbox/client'
import { Toolbox } from '~/plugins/toolbox/shared'

type Props<Type> = {
  appSession: AppSessionType
  cleanValues?: (values: Type) => Type
}

export const useLogic = <Type,>({ appSession, cleanValues }: Props<Type>) => {
  const triggerEventMutation = Api.dataConnector.triggerEvent.useMutation()

  const update = Api.appSession.update.useMutation()

  const triggerHttpEvent = async (eventKey: string) => {
    await triggerEventMutation.mutateAsync({
      appId: appSession.appId,
      providerKey: 'http',
      providerTriggerKey: 'NewRequest',
      appSessionId: appSession.id,
      payload: {
        eventKey,
        _version: 2,
      },
    })
  }

  const save = async (onboarding: any) => {
    try {
      const values = cleanValues?.(onboarding) ?? onboarding

      const onboardingUpdated = Toolbox.Utility.trimNullValues({
        ...appSession.values.onboarding,
        ...values,
      })

      await update.mutateAsync({
        where: {
          id: appSession.id,
        },
        data: {
          values: {
            ...appSession.values,
            onboarding: onboardingUpdated,
          },
        },
      })
    } catch (error) {
      console.error('Unknown Error', error)
    }
  }

  const submitOnboarding = async () => {
    await update.mutateAsync({
      where: {
        id: appSession.id,
      },
      data: {
        statusOnboarding: 'DONE',
      },
    })
  }

  const saveDebounce = ToolboxClient.useDebounceFunction(save, 1000, true) as (
    values: any,
  ) => Promise<void>

  return {
    isLoading: update.isLoading,
    save,
    saveDebounce,
    triggerHttpEvent,
    submitOnboarding,
  }
}
